import { LOCALE_ID, NgModule } from '@angular/core';
import { BrowserModule, BrowserTransferStateModule } from '@angular/platform-browser';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { ServiceWorkerModule } from '@angular/service-worker';
import { environment } from '../environments/environment';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { HttpClient, HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { CoreModule } from './core/core.module';
import { BrowserStateInterceptor } from './interceptor/browser-state.interceptor';
import { LoaderInterceptorService } from './interceptor/loader.interceptor';
import { HeaderService } from './core/header.services';
import { OverlayModule } from '@angular/cdk/overlay';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { SharedModule } from './shared/shared.module';
import { NgxChartsModule } from '@swimlane/ngx-charts';
import { InfiniteScrollModule } from 'ngx-infinite-scroll';
import { NgxGoogleAnalyticsModule } from 'ngx-google-analytics';
import { RecaptchaModule, RecaptchaSettings, RECAPTCHA_LANGUAGE, RECAPTCHA_SETTINGS } from 'ng-recaptcha';
import { registerLocaleData } from '@angular/common';
import localeSwedish from '@angular/common/locales/sv';
import { NgcCookieConsentModule } from 'ngx-cookieconsent';

export function TranslationLoaderFactory(http: HttpClient) {
  return new TranslateHttpLoader(http);
}

registerLocaleData(localeSwedish);
@NgModule({
  declarations: [AppComponent],
  imports: [
    CoreModule,
    BrowserModule.withServerTransition({ appId: 'serverApp' }),
    AppRoutingModule,
    NgxChartsModule,
    InfiniteScrollModule,
    TranslateModule.forRoot({
      loader: { provide: TranslateLoader, useFactory: TranslationLoaderFactory, deps: [HttpClient] }
    }),
    BrowserAnimationsModule,
    OverlayModule,
    HttpClientModule,
    BrowserTransferStateModule,
    FontAwesomeModule,
    SharedModule,
    RecaptchaModule,
    NgxGoogleAnalyticsModule.forRoot(environment.GoogleAnalyticsCode),
    NgcCookieConsentModule.forRoot({ cookie: { domain: '' } }),
    ServiceWorkerModule.register('ngsw-worker.js', { enabled: environment.production })
  ],
  providers: [
    { provide: HTTP_INTERCEPTORS, useClass: BrowserStateInterceptor, multi: true },
    { provide: HTTP_INTERCEPTORS, useClass: LoaderInterceptorService, multi: true },
    {
      provide: RECAPTCHA_SETTINGS,
      useValue: {
        siteKey: environment.reCaptchaSiteKey
      } as RecaptchaSettings
    },
    {
      provide: RECAPTCHA_LANGUAGE,
      useValue: 'sv' // use Swedish language
    },

    HeaderService
  ],
  bootstrap: [AppComponent]
})
export class AppModule {}
